import { useQuery } from '@tanstack/react-query';

import * as Api from 'contracts/api';
import { RequestAgent } from 'modules/request-agent';
import { useNotify } from 'pages/components/SnackBarProvider';
import { UseExposedQueryOptions } from 'queries/types';
import { throwResponseError } from 'queries/utils';
import isOkResponse from 'utils/is-ok-response';

export function useRobots<TData = Api.V3.Search.Robots.Response>(
    options?: UseExposedQueryOptions<Api.V3.Search.Robots.Response, Error, TData>
) {
    const notify = useNotify();
    return useQuery<Api.V3.Search.Robots.Response, Error, TData>({
        ...options,
        queryKey: Api.V3.Search.Robots.QueryKey(),
        queryFn: async () => {
            try {
                const response = await new RequestAgent().public.get(Api.V3.Search.Robots.Endpoint());

                if (isOkResponse(response)) {
                    return response.data;
                } else {
                    throwResponseError(response);
                }
            } catch (error) {
                notify.openNotification({ level: 'error', message: error.message });
                throw error;
            }
        }
    });
}
